import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import * as Constants from "common/constants";
import * as General from "common/general";
const LoadIFrame = () => {
	const [iframeUrl, setIframeUrl] = useState("");
	const navigate = useNavigate();
	useEffect(() => {
		const queryParams = new URLSearchParams(window.location.search);
		const code = queryParams.get("code");
		const GetIframeUrlSuccess = (responseObject) => {
			if (responseObject.active) {
				if (responseObject.embeddedDashboardId) {
					navigate(`/dashboards?embeddedId=${responseObject.embeddedDashboardId}`, { replace: true });
				} else {
					setIframeUrl(responseObject.iframeURL);
				}
			}
		};
		// Callback for failed API response
		const GetIframeUrlFailure = () => {};
		const endPoint = `${Constants.GetEndPoint}/tbl_menus/code/${code}`;
		General.GetFromEndPoint(endPoint, null, null, GetIframeUrlSuccess, GetIframeUrlFailure);
	}, [window.location.search, navigate]);
	return <div>{iframeUrl && <iframe src={iframeUrl} title="Embedded Content" width="100%" height="1000" />}</div>;
};
export default LoadIFrame;
